interface EasykitModeBannerProps {
  /** Tailwind color suite for the container: bg-${tone}-50 border-${tone}-200 etc. */
  tone: 'amber' | 'blue' | 'purple';
  /** Tailwind color class for the left side bar (task-type color). */
  sideBarColor: string;
  title: string;
  subline?: string | null;
  hint?: string | null;
  onCancel: () => void;
}

/**
 * Shared presentation for the three EK transient-mode banners (move / schedule /
 * create). Container + tone-specific colors, left side-bar color, title +
 * optional subline, optional hint, Annuleren button.
 */
export function EasykitModeBanner({ tone, sideBarColor, title, subline, hint, onCancel }: EasykitModeBannerProps) {
  const colors = TONE_COLORS[tone];
  return (
    <div className={`mx-4 lg:mx-8 mb-3 ${colors.container} border rounded-lg overflow-hidden`}>
      <div className="flex items-center gap-3">
        <div className={`w-1.5 self-stretch ${sideBarColor} shrink-0`} />
        <div className="flex-1 min-w-0 py-2.5">
          <p className="text-sm font-bold text-td-navy truncate">{title}</p>
          {subline && <p className="text-xs text-td-muted truncate mt-0.5">{subline}</p>}
        </div>
        {hint && <span className={`text-xs ${colors.hint} shrink-0`}>{hint}</span>}
        <button
          type="button"
          onClick={onCancel}
          className={`shrink-0 mr-3 px-3 py-1.5 text-xs font-semibold rounded-lg border transition-colors ${colors.button}`}
        >
          Annuleren
        </button>
      </div>
    </div>
  );
}

const TONE_COLORS = {
  amber:  { container: 'bg-amber-50 border-amber-200',   hint: 'text-amber-600',  button: 'text-amber-800 bg-amber-100 border-amber-300 hover:bg-amber-200' },
  blue:   { container: 'bg-blue-50 border-blue-200',     hint: 'text-blue-600',   button: 'text-blue-800 bg-blue-100 border-blue-300 hover:bg-blue-200' },
  purple: { container: 'bg-purple-50 border-purple-200', hint: 'text-purple-600', button: 'text-purple-700 border-purple-300 bg-transparent hover:bg-purple-100' },
} as const;
